import React, {useContext} from 'react';
import {FirebaseContext} from "../../context";
import {
  AppBar,
  Button,
  Divider,
  List, ListItem, ListItemButton, ListItemIcon, ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { AccountBalance, Category, Settings, ChevronRight } from '@mui/icons-material';
import TabNavBar from "../../components/TabNavBar";
import {RoutingContext} from "../../routing";
import './Profile.scss';

function Profile({saving}) {
  const firebase = useContext(FirebaseContext);
  const {navigateToLogin, navigateToSettings, navigateToAccounts, navigateToCategories} = useContext(RoutingContext);
  const {user, signOut} = firebase;

  const logout = () => {
    signOut();
    navigateToLogin();
  }

  return (<>
      <AppBar color="transparent" position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Profile
          </Typography>
        </Toolbar>
      </AppBar>

      <div className='screen-content profile-screen'>
        <div className="current-user">
          Logged in as <span className="username">{user && user.displayName}</span>
        </div>

        <List>
          <Divider />
          <ListItem disableGutters>
            <ListItemButton onClick={navigateToAccounts}>
              <ListItemIcon><AccountBalance /></ListItemIcon>
              <ListItemText primary="Accounts" />
              <ChevronRight />
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem disableGutters>
            <ListItemButton onClick={navigateToCategories}>
              <ListItemIcon><Category /></ListItemIcon>
              <ListItemText primary="Categories" />
              <ChevronRight />
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem disableGutters>
            <ListItemButton onClick={navigateToSettings}>
              <ListItemIcon><Settings /></ListItemIcon>
              <ListItemText primary="Advanced Settings" />
              <ChevronRight />
            </ListItemButton>
          </ListItem>
          <Divider />
        </List>

        <div className="logout-button">
          <Button onClick={logout} fullWidth={true} color="error">
            Logout
          </Button>
        </div>
      </div>

      <TabNavBar value="profile" />
    </>
  );
}

export default Profile;
